import React from 'react';
import classnames from 'classnames';

export interface DrawerHeaderProps {
  tag?: string;
  className?: string;
}

const DrawerHeader: React.FunctionComponent<DrawerHeaderProps> = ({
  tag: Tag = 'div',
  children,
  className = '',
  ...otherProps
}) => {
  return (
    // https://github.com/Microsoft/TypeScript/issues/28892
    // @ts-ignore
    <Tag
      className={classnames('mdc-drawer__header', className)}
      {...otherProps}
    >
      {children}
    </Tag>
  );
};

export default DrawerHeader;
